import React, {useState, useEffect} from 'react';
import { useApi } from "../../shared/api";
import type {IfaqApiResponse, Ibanner, Ifaq, IhomeContent} from '../../types'
import { FAQ } from './FAQ';

interface FaqsOnlyProps {
    limit?: number;
    showContactButton?: boolean;
    showHeading?: boolean;
  }
export const FaqsOnly: React.FC<FaqsOnlyProps> = ({
  limit,
  showContactButton,
  showHeading,
}) => {
  const [faqs, setFaqs] = useState<Ifaq[]>([]);
  const [error, setError] = useState<string | null>(null);
  const API = useApi();
  const fetchAllFaqas = () =>{
    return API.API_V1.getAllFaqs()
  }
  
  const setAllFaqs = (data:IfaqApiResponse) =>{
    const flattenedFaqs = Object.values(data.data).flat(); // Adjusted to match expected API response
    setFaqs(flattenedFaqs);
  }
  
const fetchAllData = async () =>{
  try {
    const [faqs] = await Promise.all([fetchAllFaqas()]);
    setAllFaqs(faqs)
  } catch (error) {
    setError("Something went wrong")
  }
}

  useEffect(() => {
 fetchAllData()
  }, []);

  return (
    <section className="container">
      <div className="faq-content">
        {/* Render the heading only if showHeading is true */}
        {showHeading && <h1>FAQS</h1>}

        {/* Show error messages if there's an error */}
        {error && <p className="error-message">{error}</p>}

        {/* Render FAQ items */}
            <FAQ faqs={faqs} limit={limit}  section="Home Page FAQs"/>
      </div>
    </section>
  );
};